{
  "@context": "https://hubmapconsortium.github.io/ccf-ontology/ccf-context.jsonld",
  "@type": "ccf:Donor",
  "samples": {
    "@type": "ccf:Sample",
    "rui_location": {
      "@type": "ccf:SpatialEntity",
      "@embed": "@always",
      "placement": {
        "@type": "ccf:SpatialPlacement"
      }
    },
    "sections": {
      "@type": "ccf:Sample",
      "datasets": {
        "@type": "ccf:Dataset",
        "@embed": "@always"
      }
    },
    "datasets": {
      "@type": "ccf:Dataset",
      "@embed": "@always"
    }
  }
}
